/**
 * User-state islands — auth-aware client components mounted INSIDE
 * other blocks / system pages. They read from
 * {@code UserResourceSource} / {@code LearningSource.enrollments} and
 * render their own loading / anonymous / loaded states.
 *
 * <p>These are NOT registered in {@code genericBlocks} — they're not
 * page-droppable. System pages (BlogDetailLayout, course detail,
 * video detail) and custom blocks mount them.
 */
export { WatchLaterButton, type WatchLaterButtonProps } from './WatchLaterButton';
export { LikeButton, type LikeButtonProps } from './LikeButton';
export { SubscribeButton, type SubscribeButtonProps } from './SubscribeButton';
export { WishlistButton, type WishlistButtonProps } from './WishlistButton';
export { WatchProgress, type WatchProgressProps } from './WatchProgress';
export { EnrollButton, type EnrollButtonProps } from './EnrollButton';
export { ProgressBar, type ProgressBarProps } from './ProgressBar';
export { ReviewComposer, type ReviewComposerProps } from './ReviewComposer';
export { ContinueLearning, type ContinueLearningProps } from './ContinueLearning';
export {
  AnonymousFallback,
  ButtonSkeleton,
  InlineSkeleton,
  CardSkeleton,
  IslandKeyframes,
  type AnonymousFallbackProps,
} from './_shared';
